import React, { useState } from 'react';
import './ImageZoom.css';

function ImageZoom() {
    const [isZoomVisible, setIsZoomVisible] = useState(false);
    const [zoomPosition, setZoomPosition] = useState({ backgroundPosition: '0% 0%' });

    const handleMouseEnter = () => setIsZoomVisible(true);
    const handleMouseLeave = () => setIsZoomVisible(false);

    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.target.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;
        setZoomPosition({ backgroundPosition: `${x}% ${y}%` });
    };

    return (
        <div className='image-zoom-container'>
            <div className='area-fullscreen-product-img'
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onMouseMove={handleMouseMove}
            >
                <img src={"https://http2.mlstatic.com/D_NQ_NP_828722-MLB31785567188_082019-O.webp"} alt="Produto" />
            </div>

            {/* Div de Zoom */}

            {isZoomVisible && (
                <div
                    className='zoom-area'
                    style={{
                        backgroundImage: "url('https://http2.mlstatic.com/D_NQ_NP_828722-MLB31785567188_082019-O.webp')",
                        ...zoomPosition,
                    }}
                ></div>
            )}
        </div>
    );
}

export default ImageZoom;
